export { SeatsIcon } from './seats'
